import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { Breadcrumbs, BreadcrumbItem, Title1, ButtonIcon, SecondaryButton } from '@hz-design-system/web-ui';

import Classes from './CategoryBreadcrumbs.module.scss';

import { TL1PageClientConfig } from 'types/TL1PageClientConfig';

type TCategoryBreadcrumbsProps = {
  l1Category: TL1PageClientConfig['l1Category'];
};

const CategoryBreadcrumbs = ({ l1Category: { name } }: TCategoryBreadcrumbsProps) => {
  const { t } = useI18nContext();

  return (
    <>
      <div className={Classes.root}>
        <SecondaryButton onClick={() => window.history.back()} className={Classes.wide}>
          <ButtonIcon name="back" />
          {t('common:page.navigation.back')}
        </SecondaryButton>

        <Breadcrumbs>
          <BreadcrumbItem icon="home" link="/">
            {t('common:page.navigation.home')}
          </BreadcrumbItem>
          <BreadcrumbItem isCurrentPage={true}>{name}</BreadcrumbItem>
        </Breadcrumbs>
      </div>

      <Title1 className={Classes.title}>{name}</Title1>
    </>
  );
};

export default CategoryBreadcrumbs;
